export class Afpaynotif {
  amount : String;
  msisdn : String;
  responseCode: String;
  responseMessage: String;
  afpayTransactionId: String;
  token: String;
  quantity: String;
  offrereference: String;
  offrelibelle: String;
  offreprix: String;
  offreduree: String;
  additonal: String;
          }
